import * as R from 'ramda'

const imgA = require('../../../assets/v2/icon_client_level_a.png')
const imgB = require('../../../assets/v2/icon_client_level_b.png')
const imgC = require('../../../assets/v2/icon_client_level_c.png')
const imgD = require('../../../assets/v2/icon_client_level_d.png')

export const accountLevel: {
  [key: number]: string;
} = {
  4: 'D',
  3: 'C',
  2: 'B',
  1: 'A'
}

export const displayAccountLevel = (level: number) => {
  switch (level) {
    case 1:
      return imgA
    case 2:
      return imgB
    case 3:
      return imgC
    case 4:
      return imgD
  }
}

export const accountLevelKeys = R.keys(accountLevel)
export const accountLevelValues = R.values(accountLevel)
